// #region Imports
import { defineComponent } from "vue";
import { DxTabPanel } from "devextreme-vue/tab-panel";
// #endregion
// #region Schema
const tSchema = {
    pages: [
        {
            name: "common",
            label: "Allgemein",
            formName: "Identity.UserClaims"
        },
        {
            name: "users",
            label: "Benutzer"
        },
        {
            name: "addresses",
            label: "Adressen"
        },
        {
            name: "oci_login",
            label: "OCI-Anmeldung"
        },
        {
            name: "oci_parameters",
            label: "OCI-Parameter"
        }
    ]
};
// #endregion
// #region Core
export default defineComponent({
    // #region Vars
    name: 'g-account-edit',
    mixins: [appHost.mixins.modal],
    // #endregion
    // #region Components
    components: {
        DxTabPanel
    },
    // #endregion
    // #region Properties
    props: {
        accountId: {
            type: String,
            required: true,
            default: ''
        }
    },
    data: () => ({
        _schema: tSchema
    }),
    // #endregion
});
// #endregion
